import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { Typography } from "@mui/material";

const ChartReport = ({ lastMonthData, title, dataKey }) => {
  // Prepare chart data
  const chartData = lastMonthData.map((item) => ({
    month: item.month, // Month name for the X-axis
    onboarded: item[dataKey], // The count for the dataKey (e.g., vendorCount)
  }));

  return (
    <Paper
      sx={{
        pr: 0,
        padding: 2,
        borderRadius: 2,
        marginTop: 2,
        boxShadow: 2,
      }}
    >
      {/* Header Section */}
      <Stack mt={1.5} pr={3.5} mb={2}>
        <div className="flex justify-between items-center">
          <h3 className="font-bold text-xl">{title}</h3>
        </div>
      </Stack>

      {/* Responsive Bar Chart */}
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={chartData}
          margin={{
            top: 10,
            right: 5,
            left: 5,
            bottom: 5,
          }}
          barSize={20}
        >
          {/* Grid */}
          <CartesianGrid horizontal={false} vertical={false} />

          {/* Gradient Definition */}
          <defs>
            <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#418cff" />
              <stop offset="100%" stopColor="#ffffff" />
            </linearGradient>
          </defs>

          {/* X-Axis */}
          <XAxis
            scale="point"
            tick={false}
            padding={{ left: 20, right: 20 }} // adds space before first and after last bar
            label={{
              value: "Months",
              position: "insideBottom",
              offset: -10,
              dy: 17,
              style: { fill: "#333", fontSize: "14px", fontWeight: "bold" },
            }}
          />

          {/* Y-Axis */}
          <YAxis
            label={{
              value: "Onboarded",
              angle: -90,
              position: "insideLeft",
            }}
            tickFormatter={(value) => Math.round(value)}
            allowDecimals={false}
            interval={1}
          />

          {/* Tooltip */}
          <Tooltip
            formatter={(value, name, props) => [
              `${value}`, // Displays the onboarded count
              `${props.payload.month}`, // Displays the month
            ]}
            labelFormatter={() => ""} // Removes the default X-axis label
          />

          {/* Bar */}
          <Bar
            dataKey="onboarded"
            fill="url(#barGradient)"
            radius={[6, 6, 0, 0]} // Rounded top corners
          />
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  );
};

export default ChartReport;
